import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createBlock as _createBlock, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26aad21e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-center mb-4" }
const _hoisted_2 = { class: "text-center fw-bold mb-0 fs-5 pb-2" }
const _hoisted_3 = { class: "p-3 p-lg-4 shadow rounded-4 bg-white mb-4 mb-lg-5" }
const _hoisted_4 = { class: "detail-header border-bottom mb-4 pb-4 position-relative" }
const _hoisted_5 = { class: "pl-0" }
const _hoisted_6 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["onSubmit"]
const _hoisted_10 = { class: "me-lg-3 me-0 mb-4 mb-lg-0 w-100" }
const _hoisted_11 = ["placeholder", "rows"]
const _hoisted_12 = {
  key: 0,
  class: "invalid-error"
}
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "mb-2 d-flex justify-content-center" }

import { computed, ComputedRef, nextTick, onUnmounted, onMounted, ref, watch, watchEffect } from 'vue'
import Button from '@/components/button/index.vue'
// import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import MessageItemDirectChat from '../components/MessageItemDirectChat.vue'
// import Avatar from '@/components/avatar'
import { translate } from '@/languages/i18n'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import ChatModal from '@/views/user/conversations/components/ChatModal.vue'
import DeleteChatModal from '@/views/user/conversations/components/DeleteChatModal.vue'
import DeleteChatSuccessModal from '@/views/user/conversations/components/DeleteChatSuccessModal.vue'
import Loading from '@/components/loading/index.vue'

//validate
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

//constant
import { DEFAULT_MIN_LENGTH } from '@/constants/number'
import { useRoute, useRouter, onBeforeRouteLeave } from 'vue-router'
import { useStore } from 'vuex'
import { CHAT_STORE, ROOT_STORE } from '@/store/constants'
import { DirectChatType } from '@/store/modules/chat'

import VirtualList from 'vue3-virtual-scroll-list'
import { useWebSocket } from '@/use/useWebsocket'
import { debounce } from 'lodash'
import commonService from '@/services/common.service'
import chatService from '@/services/chat.services'
import { customMaxLength, customMinLength } from '@/utils'
import { useChat } from '@/composables/chat'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const store = useStore()
const router = useRouter()
const { connection, reconnect } = useWebSocket('chatChannel', {
  onConnected: () => {
    // Only re-fetch data if the page has finished initializing its initial data
    // Ensure the API is re-fetched in both cases: remaining on the tab and background reconnection
    if (getData.value) {
      fetchChatRoomData()
    }
  },
})

const direct_chat = computed<ComputedRef<DirectChatType>>(() => store.getters[CHAT_STORE.GETTERS.GET_DIRECT_CHAT])
const loading = computed<ComputedRef<DirectChatType>>(() => store.getters[CHAT_STORE.GETTERS.LOADING_CHAT])
const isMobile = computed<ComputedRef<boolean>>(() => store.getters[ROOT_STORE.GETTERS.CHECK_MOBILE_DEVICE])
const message = computed(() => store.getters[CHAT_STORE.GETTERS.GET_MESSAGE_SOCKET])
const page = computed(() => store.getters[CHAT_STORE.GETTERS.PAGE_CHAT])
const { idComment, sendMessage, scrollMessage, addReconnectListeners, removeReconnectListeners, getData } = useChat()

const rules = computed(() => {
  return {
    content: {
      maxLength: (value: string) => customMaxLength(value, 500),
    },
  }
})

const formData = ref({
  content: '',
})
const virtual_list = ref()

const v$ = useVuelidate(rules, formData)

const onSubmit = async (): Promise<void> => {
  v$.value.$touch()

  isCheckedNGContent.value = false
  await checkNGContent()
  while (!isCheckedNGContent.value) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }

  if (v$.value.$invalid || ngKeyContent.value) return

  store.dispatch(CHAT_STORE.ACTIONS.SEND_MESSAGE_DIRECT, {
    community_id: route.params?.id,
    chatroom_id: route.params?.chatroom_id,
    content: formData.value?.content,
    create_by_admin: route.path.includes('admin'),
  })
  updateMessageRead()
  sendMessage.value = true
  v$.value.$reset()
  Object.assign(formData.value, {
    content: '',
  })
}

const handleClickBack = (): void => {
  router.go(-1)
}

watch(
  () => message.value,
  () => {
    if (message.value?.chatroom_id === route.params?.chatroom_id) {
      if (message.value?.type === 'create') {
        store.dispatch(CHAT_STORE.ACTIONS.ADD_DIRECT_MESSAGE, message.value)
      }
      if (message.value?.type === 'delete') {
        store.dispatch(CHAT_STORE.ACTIONS.REMOVE_DIRECT_MESSAGE_WS, message.value.id)
      }
    }
  },
  {
    deep: true,
  }
)

const dataLoadMore = ref()

watchEffect(() => {
  dataLoadMore.value = [...direct_chat.value.data]
  dataLoadMore.value.unshift({ id: 'first_chat_page' })
})

watch(
  () => direct_chat.value.data,
  async () => {
    await nextTick()
    const scroller = document.querySelector('.scroller') as HTMLElement
    if (page.value === 1) {
      // not use function scrollToBottom from virtual_list may cause infinite loop
      // await virtual_list.value?.scrollToBottom()
      virtual_list.value.scrollTop = 9999999999
      if (scroller) scrollMessage(scroller, 9999999999)
    } else {
      virtual_list.value.scrollTop = 8000
      if (scroller) scrollMessage(scroller, sendMessage.value ? 9999999999 : 8000)
    }
  },
  {
    deep: true,
  }
)

onMounted(async () => {
  addReconnectListeners(connection, reconnect)
  idComment.value = route.query?.target_content_id
  await fetchChatRoomData()
  getData.value = true
})

watchEffect(() => {
  if (!direct_chat.value?.chatroom?.id && getData.value) {
    router.replace('/404')
  }
})

onMounted(() => {
  virtual_list.value = document.querySelector('.scroller')
})

const isCheckedNGContent = { value: false }
const ngKeyContent = ref<boolean>(false)
const checkNGContent = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.content.$model })
  ngKeyContent.value = data.data?.data?.has_ngword
  isCheckedNGContent.value = true
}, 200)

onBeforeRouteLeave(() => {
  store.dispatch(CHAT_STORE.ACTIONS.SET_PAGE_CHAT, 0)
})

const updateMessageRead = async () => {
  try {
    await chatService.updateMessageReadDirect(route.params?.chatroom_id, { create_by_admin: route.path.includes('admin') })
  } catch (error) {
    console.log(error)
  }
}

const fetchChatRoomData = async () => {
  if (route.params?.id) {
    await store.dispatch(CHAT_STORE.ACTIONS.GET_DIRECT_CHAT, {
      community_id: route.params?.id,
      chatroom_id: route.params?.chatroom_id,
      create_by_admin: route.path.includes('admin'),
      page: 1,
      target_content_id: route.query?.target_content_id,
    })
  }
}

onUnmounted(() => {
  removeReconnectListeners()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(translate)('SM66header')), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", null, _toDisplayString(_unref(translate)('chatContent1')), 1),
          _createElementVNode("p", null, _toDisplayString(_unref(translate)('chatContent2')), 1)
        ])
      ]),
      (_unref(loading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
        : _createCommentVNode("", true),
      _createVNode(_unref(VirtualList), {
        class: "scroller",
        ref: (_value, _refs) => {
          _refs['virtual_list'] = _value
          virtual_list.value = _value
        },
        style: {"height":"540px","overflow-y":"auto","overflow-x":"hidden"},
        "estimate-size": 80,
        keeps: 1000,
        "data-key": 'id',
        "data-sources": dataLoadMore.value,
        "data-component": MessageItemDirectChat,
        "extra-props": { partner_post: _unref(direct_chat).chatroom, is_admin: _unref(route).path.includes('/admin'), id_comment: _unref(idComment) }
      }, null, 8, ["data-sources", "extra-props"]),
      (_unref(direct_chat).chatroom?.can_chat)
        ? (_openBlock(), _createElementBlock("form", {
            key: 1,
            onSubmit: _withModifiers(onSubmit, ["prevent"]),
            action: "",
            class: "bg-gray p-3 d-flex form-chat"
          }, [
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("textarea", {
                placeholder: _unref(translate)('placeholder'),
                name: "content",
                class: _normalizeClass(['form-control p-2 ', ngKeyContent.value || _unref(v$).content.$error ? 'is-invalid' : '', _unref(isMobile) ? 'p-1' : 'p-2']),
                rows: _unref(isMobile) ? 1 : 2,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).content.$model) = $event)),
                onBlur: _cache[1] || (_cache[1] = () => (_unref(v$).content.$model = _unref(v$).content.$model.replace(/\n+$/, ''))),
                onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(checkNGContent) && _unref(checkNGContent)(...args))),
                onClick: updateMessageRead
              }, null, 42, _hoisted_11), [
                [_vModelText, _unref(v$).content.$model]
              ]),
              (ngKeyContent.value && !_unref(v$).content.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                : _createCommentVNode("", true),
              _createVNode(InputErrorMessage, {
                title: _unref(translate)('chatContent'),
                params: [_unref(DEFAULT_MIN_LENGTH), 500],
                validator: _unref(v$).content.$errors[0]?.$validator
              }, null, 8, ["title", "params", "validator"])
            ]),
            (!_unref(isMobile))
              ? (_openBlock(), _createBlock(Button, {
                  key: 0,
                  title: _unref(translate)('SO65send'),
                  type: 'secondary',
                  htmlType: 'submit',
                  class: "fw-bold mt-2",
                  disabled: !formData.value.content.trim()
                }, null, 8, ["title", "disabled"]))
              : _createCommentVNode("", true),
            (_unref(isMobile))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: _normalizeClass(['button-mobile', ngKeyContent.value || _unref(v$).content.$error || !formData.value.content.trim() ? '' : 'button-submit']),
                  htmlType: 'submit',
                  disabled: _unref(v$).content.$error || !formData.value.content.trim()
                }, _toDisplayString(_unref(translate)('SO65send')), 11, _hoisted_13))
              : _createCommentVNode("", true)
          ], 40, _hoisted_9))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(Button, {
        title: _unref(route).path.includes('admin') ? _unref(translate)('back') : _unref(translate)('SM65backChatList'),
        type: 'secondary',
        className: "mb-0 mb-lg-3",
        onClick: handleClickBack
      }, null, 8, ["title"])
    ]),
    _createVNode(ChatModal),
    _createVNode(DeleteChatModal, { isDirectChat: true }),
    (_unref(route).path === `/${_unref(route).path.split('/')[1]}/communities/${_unref(route).params?.id}/admin/direct_chat/${_unref(route).params?.chatroom_id}`)
      ? (_openBlock(), _createBlock(Loading, {
          key: 0,
          loading: _unref(loading)
        }, null, 8, ["loading"]))
      : _createCommentVNode("", true),
    _createVNode(DeleteChatSuccessModal)
  ], 64))
}
}

})